import PropTypes from 'prop-types';
import { screen } from 'components/styles/variables';
import { useTranslation } from 'react-i18next';

import { getGradePoperties } from './ReportCard';

function calculateDegrees(percentage) {
  const degreesShown = (percentage / 100) * 360;
  return degreesShown <= 180 ? degreesShown + 90 : degreesShown - 90;
}

const UserTake = ({ recommended, total }) => {
  const { t } = useTranslation();
  const percentage = Math.round((recommended / total) * 100);
  const properties = getGradePoperties(percentage);

  return (
    <div className="box">
      <div className="active-border">
        <div className="circle">{percentage || '-'}%</div>
      </div>
      <div className="text">
        <h4>{t(`comparison.userTake.wouldBuyAgain`)}</h4>
        <p>
          {total || '-'} {t(`comparison.userTake.ratings`)}
        </p>
      </div>
      <style jsx>{`
        .circle {
          font-size: 2vh;
          font-weight: bold;
          justify-content: center;
          vertical-align: middle;
          display: flex;
          align-items: center; /* align vertical */
          text-align: center;
          width: 60%;
          height: 60%;
          border-radius: 100%;
          background-color: white;
        }

        .active-border {
          flex: 0 0 auto;
          justify-content: center;
          align-items: center;
          display: flex;
          width: 10vh;
          height: 10vh;
          margin: 0;
          text-align: center;
          border-radius: 100%;
          background-color: ${properties.color};
          background-image: linear-gradient(
              ${calculateDegrees(percentage)}deg,
              transparent 50%,
              ${properties.color} 50%
            ),
            linear-gradient(90deg, white 50%, transparent 50%);
        }

        .box {
          display: flex;
          width: 45%;
          position: relative;
          vertical-align: middle;
        }

        .text {
          display: flex;
          vertical-align: middle;
          flex-direction: column;
          justify-content: center;
          padding-left: 5px;
          line-height: 0.9em;
          font-size: 0.7em;
          left: 30%;
        }

        h4 {
          font-size: 1.3em;
          margin-top: 0px;
          margin-bottom: 0px;
          line-height: 100%;
        }

        p {
          margin-top: 0px;
          margin-bottom: 0px;
          line-height: 1.5em;
        }

        @media (min-width: ${screen.smMin}) {
          .text {
            font-size: initial;
            padding-left: 15px;
          }
        }
      `}</style>
    </div>
  );
};
UserTake.propTypes = {
  recommended: PropTypes.number,
  total: PropTypes.number,
};

export default UserTake;
